import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
//import tailwindConfig from '../../../tailwind.config';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

//const tabletScreen = tailwindConfig.theme.screens.lg.replace('px', '')

// Wait for the DOM content to load - Magnific Popup uses jQuery
document.addEventListener('DOMContentLoaded', function () {
	window.addEventListener("load", function(e) {
		$('[data-js="popup-video"]').magnificPopup({
			type: 'iframe',
			mainClass: 'mfp-video-wrapper',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false,
		});
	}, false);
});

export default function(){
	// Scrolling title
	const titles = document.querySelectorAll( '[data-js="scroll-title"]' )
	
	if ( titles.length > 0 ){
		titles.forEach(title => {
			gsap.to( title, {
				scrollTrigger: {
					trigger: title,
					scrub: 0.9,
					refreshPriority: -1,
					start: 'top center+=150px',
					end: 'bottom top+=100px',
					//markers: true,
				},
				x: `-${ title.scrollWidth - ( window.innerWidth * 0.9 ) }px`,
				ease: 'none'
			});
		});
	}




	// Text Reveal
	const text = document.querySelector('[data-target="text-reveal"]');
	
	if ( text ){
		const paragraphs = text.querySelectorAll('p');
		const splitText = new SplitText(paragraphs, { type: 'chars,words' });
		
		gsap.fromTo(text, {
			transformOrigin: '0% 50%',
			rotate: 0
		}, {
			ease: 'none',
			rotate: 0,
			scrollTrigger: {
				trigger: text,
				start: 'top bottom',
				end: 'bottom bottom',
				scrub: true,
			}
		});
	
		gsap.fromTo(splitText.chars, {
			'will-change': 'opacity',
			opacity: 0.15,
		}, {
			ease: 'none',
			opacity: 1,
			stagger: 0.05,
			scrollTrigger: {
				trigger: text,
				start: 'top bottom-=20%',
				end: 'center top+=20%',
				scrub: true,
				// markers: true,
			}
		});
	}

}

